export const match = (str: string, keyword: string) => {
  const parts: (string | string[])[] = []
  for (let i = 0, j = 0; i < str.length; i++) {
    if (str[i].toUpperCase() === keyword[j].toUpperCase()) {
      j++
      if (j === keyword.length || i === str.length - 1) {
        parts.push([...str.slice(i - j + 1, i + 1)])
        j = 0
      }
      continue
    }
    if (str[i] !== keyword[j]) {
      if (j === 0) {
        parts.push(str[i])
      }
      if (j === 1) {
        parts.push(...str.slice(i - 1, i + 1))
      }
      if (j > 1) {
        parts.push([...str.slice(i - j, i)])
        parts.push(str[i])
      }
      j = 0
    }
  }
  return parts
}
